import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import Corpo from "../components/Corpo";
import Popup from "../components/Popup";
import PopupHistoricoPartida from "../components/PopupHistoricoPartida";

import btnYellow from "../assets/img/btn-xs-yellow.png";
import btnRed from "../assets/img/btn-xs-red.png";
import btnGreen from "../assets/img/btn-xs-green.png";
import btnEnviarPergunta from "../assets/img/btn-enviar-pergunta-loock.png";
import btnWyellow from "../assets/img/btn-xs-wrong-yellow.png";
import btnWred from "../assets/img/btn-xs-wrong-red.png";
import btnWgreen from "../assets/img/btn-xs-wrong-green.png";
import btnRyellow from "../assets/img/btn-xs-right-yellow.png";
import btnRred from "../assets/img/btn-xs-right-red.png";
import btnRgreen from "../assets/img/btn-xs-right-green.png";

import { closeGlobalPopup, globalPopup } from "../services/popup";

import { startMatchSigleplayer} from "../services/match-service";
import { findMatchHistory } from "../services/match-service";
import { countQuestionsResponded } from "../services/match-service";
import { countQuestionsCorrect } from "../services/match-service";

const TYPE_SINPLEPLAYER = 'single';

export default function TabSingle(props) {
  
  const [showPopup, setShowPopup] = useState(false);
  const [historicoPartida, setHistoricoPartida] = useState([]);
  const [showPopupHistorico, setShowPopupHistorico] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState({});
  const [scoreLifeRepresentation, setScoreLifeRepresentation] = useState([]);
  const [scoreMultiplier, setScoreMultiplier] = useState([]);
  const [scoreMultiplierIndex, setScoreMultiplierIndex] = useState(0);
  const [scorePoints, setScorePoints] = useState(0);
  const [timeNivelDificuldade, setTimeNivelDificuldade] = useState(0);
  const [lstPerguntas, setLstPerguntas] = useState([]);
  const [corNivelDificuldade, setCorNivelDificuldade] = useState("");
  const [nivelDificuldade, setNivelDificuldade] = useState("");

  const routeParam = props.location.pathname
    .replace("/tab/single/", "")
    .split("/");

  let getIdCategory = () => {
    return routeParam[0];
  };

  let getIdTheme = () => {
    return routeParam[1];
  };

  let nao = () => {
    setShowPopup(false);
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    window.GLOBALS.isInMultiplayer = false;
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  let sim = () => {
    setShowPopup(false);
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    window.GLOBALS.isInMultiplayer = true;
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  let fecharPopupHistorico = () => {
    setShowPopupHistorico(false);
  };

  let mudaTema = () => {
    props.history.push("/tab/theme/single/" + getIdCategory());
  };

  let loadHistorico = () => {
    findMatchHistory(getIdTheme()).then((res) => {
      setHistoricoPartida(res.data);
    });
  };

  let respondeu = (indexPergunta) => {
    return lstPerguntas[indexPergunta].respondeu;
  };

  let acertou = (indexPergunta) => {
    return (
      lstPerguntas[indexPergunta].respondeu && lstPerguntas[indexPergunta].acertou
    );
  };

  let errou = (indexPergunta) => {
    return (
      lstPerguntas[indexPergunta].respondeu && !lstPerguntas[indexPergunta].acertou
    );
  };

  let difRespondeu = (indexPergunta) => {
    let cores = ["green", "yellow", "red"];
    let dif =
      window.GLOBALS.actualSingleMatch.questions[indexPergunta].dificuldade;
    return cores["FMD".indexOf(dif)];
  };

  let btnCorNivelDificuldade = (corNivelDificuldade) => {
    switch (corNivelDificuldade) {
      case "yellow":
        return btnYellow;

      case "red":
        return btnRed;

      case "green":
        return btnGreen;

      default:
        return btnYellow;
    }
  };

  let btnDifRespondeuW = (corNivelDificuldade) => {
    switch (corNivelDificuldade) {
      case "yellow":
        return btnWyellow;

      case "red":
        return btnWred;

      case "green":
        return btnWgreen;

      default:
        return btnWyellow;
    }
  };

  let btnDifRespondeuR = (corNivelDificuldade) => {
    switch (corNivelDificuldade) {
      case "yellow":
        return btnRyellow;

      case "red":
        return btnRred;

      case "green":
        return btnRgreen;

      default:
        return btnRyellow;
    }
  };

  let mudaDificuldade = () => {
    switch (nivelDificuldade) {
      case "M":
        setTimeNivelDificuldade(window.CONFIG.single.secondsPerDificulties[2]);
        setCorNivelDificuldade("red");
        setNivelDificuldade("D");
        break;

      case "D":
        setTimeNivelDificuldade(window.CONFIG.single.secondsPerDificulties[0]);
        setCorNivelDificuldade("green");
        setNivelDificuldade("F");
        break;

      case "F":
        setTimeNivelDificuldade(window.CONFIG.single.secondsPerDificulties[1]);
        setCorNivelDificuldade("yellow");
        setNivelDificuldade("M");
        break;

      default:
        setTimeNivelDificuldade(window.CONFIG.single.secondsPerDificulties[1]);
        setCorNivelDificuldade("yellow");
        setNivelDificuldade("M");
        break;
    }
  };

  useEffect(() => {
    const abortController = new AbortController();

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    setSelectedTheme(window.GLOBALS.selectedTheme);

    let scorePush = [];

    for (let i = 0; i < window.GLOBALS.actualSingleMatch.totalScoreLife; i++) {
      scorePush.push({
        status: window.GLOBALS.actualSingleMatch.scoreLife - 1 >= i ? 1 : 0,
      });
    }

    setScoreMultiplier(window.CONFIG.single.scoreMultiplier);
    setScoreMultiplierIndex(window.GLOBALS.actualSingleMatch.scoreMultiplierIndex);
    setScorePoints(window.GLOBALS.actualSingleMatch.scorePoints);

    setScoreLifeRepresentation(scorePush);
    setTimeNivelDificuldade(window.CONFIG.single.secondsPerDificulties[1]);

    if (
      window.GLOBALS.actualSingleMatch.lastAnswer &&
      window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta !== -1
    ) {
      window.GLOBALS.actualSingleMatch.questions[
        window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta
      ].respondeu = true;
      
      window.GLOBALS.actualSingleMatch.questions[
        window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta
      ].acertou = window.GLOBALS.actualSingleMatch.lastAnswer.resultdoResposta === "acertou";
      
      window.GLOBALS.actualSingleMatch.questions[
        window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta
      ].dificuldade = window.GLOBALS.actualSingleMatch.lastAnswer.dificuldadeResposta;

      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    }

    setLstPerguntas(window.GLOBALS.actualSingleMatch.questions);

    setCorNivelDificuldade("yellow");

    setNivelDificuldade("M");

    if (
      localStorage.getItem("ACTUAL_DIFFICULT") !== null &&
      localStorage.getItem("ACTUAL_DIFFICULT") !== ""
    ) {
      let cores = ["green", "yellow", "red"];
      let coresPosition = [0, 1, 2];
      let dif = localStorage.getItem("ACTUAL_DIFFICULT");

      setNivelDificuldade(dif);
      setCorNivelDificuldade(cores["FMD".indexOf(dif)]);
      setTimeNivelDificuldade(
        window.CONFIG.single.secondsPerDificulties[
          coresPosition["FMD".indexOf(dif)]
        ]
      );
      localStorage.setItem("ACTUAL_DIFFICULT", "");
    }

    if (
      localStorage.getItem("PERDEU_SCORE") !== null &&
      localStorage.getItem("PERDEU_SCORE") !== ""
    ) {
      localStorage.setItem("PERDEU_SCORE", "");
      window.GLOBALS.actualSingleMatch.scoreLife--;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

      let scorePush = [];

      for (
        let i = 0;
        i < window.GLOBALS.actualSingleMatch.totalScoreLife;
        i++
      ) {
        scorePush.push({
          status: window.GLOBALS.actualSingleMatch.scoreLife - 1 >= i ? 1 : 0,
        });
      }
      setScoreLifeRepresentation(scorePush);
    }

    if (
      localStorage.getItem("CHAMA_MULTIPLIER") !== null &&
      localStorage.getItem("CHAMA_MULTIPLIER") !== ""
    ) {
      if (
        window.GLOBALS.actualSingleMatch.scoreMultiplierIndex <
        window.CONFIG.single.scoreMultiplier.length - 1
      ) {
        window.GLOBALS.actualSingleMatch.scoreMultiplierIndex++;
        setScoreMultiplierIndex(
          window.GLOBALS.actualSingleMatch.scoreMultiplierIndex
        );
      }

      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

      localStorage.setItem("CHAMA_MULTIPLIER", "");
    } else {
      window.GLOBALS.actualSingleMatch.scoreMultiplierIndex = 0;
      setScoreMultiplierIndex(
        window.GLOBALS.actualSingleMatch.scoreMultiplierIndex
      );
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
    }

    loadHistorico();

    if (
      localStorage.getItem("NAO_PERTUBE_POPUP") !== null &&
      localStorage.getItem("NAO_PERTUBE_POPUP") !== ""
    ) {
      setShowPopup(false);
      localStorage.setItem("NAO_PERTUBE_POPUP", "");
    } else {
      setShowPopup(true);
      localStorage.setItem("NAO_PERTUBE_POPUP", "");
    }

    let totalAnswers = countQuestionsResponded();
    if (totalAnswers >= 30) {
      let correct = countQuestionsCorrect();
      let percentual = correct ? Math.floor((correct / totalAnswers) * 100) : 0;
    
      if (percentual > 75) {
        globalPopup(
          "Resultado do Jogo",
          true,
          [
            {
              texto: "Não",
              acao: () => {
                closeGlobalPopup();
              },
            },
            {
              texto: "Sim",
              acao: () => {
                startMatchSigleplayer(props, getIdTheme(), TYPE_SINPLEPLAYER, getIdCategory());
              },
            },
          ],
          "Parabéns! Você acertou " + percentual + "% do questionário, deseja jogar novamente?"
        );
      } else {
        globalPopup(
          "Resultado do Jogo",
          true,
          [
            {
              texto: "Ok",
              acao: () => {
                startMatchSigleplayer(props, getIdTheme(), TYPE_SINPLEPLAYER, getIdCategory());
              },
            },
          ],
          "Você acertou " + percentual + "% do questionário! O Jogo será reiniciado"
        );
      }
    }
    return function cleanup() {
      abortController.abort();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Corpo {...props}>
      <Popup
        title="Não pertube"
        show={showPopup}
        botoes={[
          { texto: "Não", acao: () => nao() },
          { texto: "Sim", acao: () => sim() },
        ]}
      >
        <span>
          Você deseja ligar o modo "não perturbe" de maneira a não ficar
          disponível para desafios no modo multiplayer enquanto está estudando
          este tema?
        </span>
        <br />
        <br />
        <span>
          Se optar por não ser interrompido, você voltará a ficar disponível
          para partidas multiplayer automaticamente ao encerrar sua lista de
          perguntas.
        </span>
        <br />
      </Popup>

      <PopupHistoricoPartida
        title={selectedTheme?.nome}
        historico={historicoPartida}
        show={showPopupHistorico}
        fechar={() => fecharPopupHistorico()}
      />

      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-jogo tab-lista-perguntas pane pane-game">
          <div className=" scroll-content ionic-scroll">
            <div className="scroll">
              <div className="row score">
                <div className="col score-life">
                  <h5>Chance</h5>
                  <div className="score-life-panel">
                    {scoreLifeRepresentation.map((rep, index) => (
                      <div
                        className={
                          "score-life-" + index + (rep.status ? " filled" : "")
                        }
                        key={index}
                      >
                        <span>{index}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col score-multiplicador">
                  <ul>
                    <li
                      className={
                        "score-multiplicador-1x" +
                        (scoreMultiplierIndex === 0 ? " active" : "")
                      }
                    >
                      <span>{scoreMultiplier[0]}x</span>
                    </li>
                    <li
                      className={
                        "score-multiplicador-2x" +
                        (scoreMultiplierIndex === 1 ? " active" : "")
                      }
                    >
                      <span>{scoreMultiplier[1]}x</span>
                    </li>
                    <li
                      className={
                        "score-multiplicador-3x" +
                        (scoreMultiplierIndex === 2 ? " active" : "")
                      }
                    >
                      <span>{scoreMultiplier[2]}x</span>
                    </li>
                  </ul>
                </div>
                <div className="col score-points">{scorePoints} Pts</div>
              </div>

              <h2>
                <span>Escolha uma pergunta do tema:</span> {selectedTheme?.nome}
              </h2>

              <div className="perguntas">
                {lstPerguntas.map((pergunta, key) => {
                  return (
                    <div
                      id={"p" + (key + 1)}
                      className={
                        "col pergunta-button" +
                        (!respondeu(key) ? " active" : "")
                      }
                      key={key}
                    >
                      <img
                        src={btnCorNivelDificuldade(corNivelDificuldade)}
                        style={{ display: !respondeu(key) ? "" : "none" }}
                        alt="dificuldade"
                      />
                      <img
                        src={btnDifRespondeuW(difRespondeu(key))}
                        style={{ display: errou(key) ? "" : "none" }}
                        alt="respondeuw"
                      />
                      <img
                        src={btnDifRespondeuR(difRespondeu(key))}
                        style={{ display: acertou(key) ? "" : "none" }}
                        alt="respondeur"
                      />
                      <div>
                        <Link
                          to={
                            "/tab/pergunta/" +
                            pergunta.id +
                            "/" +
                            getIdTheme() +
                            "/" +
                            nivelDificuldade +
                            "/" +
                            key
                          }
                          style={{ display: !respondeu(key) ? "" : "none" }}
                        >
                          {key + 1}
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>

              <button
                type="button"
                className="button-enviar-pergunta"
                style={{ display: "none" }}
              >
                <img src={btnEnviarPergunta} alt="Enviar Pergunta" />
                <span>Enviar Pergunta</span>
              </button>

              <div className="row footer">
                <div className="col">
                  <div className="jogo-nivel">
                    <small>Dificuldade</small>

                    <div
                      className={
                        "jogo-nivel-select jogo-nivel-" + nivelDificuldade
                      }
                      onClick={() => mudaDificuldade()}
                    >
                      <span className="jogo-nivel-time">
                        {timeNivelDificuldade}s
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col jogo-historico">
                  <div className="quantidade-vezes-button">
                    <small>
                      Quantidade de vezes jogadas{" "}
                      <strong>{historicoPartida.length}x</strong>
                    </small>
                    <button
                      className="button button-md"
                      onClick={() => setShowPopupHistorico(true)}
                      style={{ fontSize: 14 }}
                    >
                      Ver
                    </button>
                  </div>
                </div>
                <div className="col jogo-tema">
                  <button
                    className="button button-md"
                    onClick={() => mudaTema(true)}
                    style={{ fontSize: 14 }}
                  >
                    Mudar o Tema
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
